"use client";
import Image from "@/node_modules/next/image";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import Box from "@mui/material/Box";
import { Skeleton } from "@mui/material";
import Link from "next/link";
import { Loader } from "../genericComponents/MainLoader/Loader";
import "./banner.css";
// import ScannerAuth from "../genericComponents/scanner-auth/ScannerAuth";
import dynamic from "next/dynamic";
const ScannerAuth = dynamic(
  () => import("../genericComponents/scanner-auth/ScannerAuth"),
  { ssr: false }
);

import { ApiService } from "@/app/services/AppService";
import Slider from "react-slick";

interface BannerProps {
  banners: any;
  categories: any;
}

interface SubCategory {
  id: number;
  slug: string; // Add all other fields that are relevant
}

const Banner: React.FC<BannerProps> = ({ banners, categories }) => {
  const [loader, setLoader] = useState(false);
  const [openInfo, setOpenInfo] = useState(false);
  const [serviceHubSlug, setServiceHubSlug] = useState("noida");
  const [slug, setSlug] = useState<undefined | string | null>(null);
  const [bannerId, setBannerId] = useState<undefined | number>();
  const [subcategories, setSubcategories] = useState<SubCategory[] | null>(
    null
  );
  const apiService = useMemo(() => new ApiService(), []);

  var settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    className: "myCustomCarouselBanner",
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  useEffect(() => {
    try {
      const storedSlug = localStorage.getItem("serviceHubSlug");
      if (storedSlug) {
        const decodedSlug = JSON.parse(atob(storedSlug));
        if (decodedSlug) {
          setServiceHubSlug(decodedSlug);
        }
      }
    } catch (error) {
      console.error("Error decoding or parsing serviceHubSlug:", error);
    }
  }, []);

  const getSubcategories = useCallback(async () => {
    try {
      const response = await apiService.get<any>(
        `${apiService.subcategories}?hubSlug=${serviceHubSlug}&categorySlug=salon-at-home`
      );
      setSubcategories(response?.object);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  }, [apiService, serviceHubSlug]);

  useEffect(() => {
    if (serviceHubSlug) {
      getSubcategories();
    }
  }, [serviceHubSlug, getSubcategories]); // Added serviceHubSlug dependency

  const updatedBannersArray =
    banners?.length === 1
      ? Array(3)
          .fill(banners[0])
          .map((item: any) => {
            const matchedCategory = categories?.find(
              (category: any) => category.id === item.categoryId
            );

            const matchedSubCategory = subcategories?.find(
              (subCategory: any) => subCategory.id === item.subCategoryId
            );

            return {
              ...item,
              slug: matchedCategory ? matchedCategory.slug : "salon-at-home",
              subSlug: matchedSubCategory ? matchedSubCategory?.slug : null,
            };
          })
      : banners?.map((item: any) => {
          const matchedCategory = categories?.find(
            (category: any) => category.id === item.categoryId
          );

          const matchedSubCategory = subcategories?.find(
            (subCategory: any) => subCategory.id === item.subCategoryId
          );

          return {
            ...item,
            slug: matchedCategory ? matchedCategory.slug : "salon-at-home",
            subSlug: matchedSubCategory ? matchedSubCategory?.slug : null,
          };
        });

  const handleClick = useCallback(
    (bannerTypeCode: number, id: number, slug: string) => {
      if (bannerTypeCode === 5) {
        setOpenInfo(true);
        setBannerId(id);
        setSlug(slug);
      }
    },
    []
  );

  return (
    <>
      {banners && banners.length > 0 && (
        <Box
          sx={{
            width: "100%",
            margin: { xs: "1rem auto 0px", sm: "3rem auto 0px" },
            backgroundColor: "white",
            borderColor: "none",
          }}
        >
          <Slider {...settings}>
            {banners && banners.length > 0
              ? updatedBannersArray.map((item: any, i: number) => (
                  <Box
                    key={i}
                    sx={{
                      padding: "1rem",
                    }}
                  >
                    {item?.bannerTypeCode !== 5 ? (
                      <Link
                        prefetch={false}
                        onClick={() => setLoader(true)}
                        href={(() => {
                          switch (item?.bannerTypeCode) {
                            case 1:
                              return item?.subSlug;

                            case 2:
                              return "/refer&earn";

                            case 3:
                              return item?.subSlug
                                ? `${serviceHubSlug}/${item?.slug}/${item?.subSlug}`
                                : `${serviceHubSlug}/${item?.slug}`;

                            case 4:
                              return `${serviceHubSlug}/${item?.slug}`;

                            // case item?.bannerTypeCode == 5:
                            //   return `${serviceHubSlug}/offers/${item?.slug}`;

                            case 6:
                              return `${serviceHubSlug}/${item?.slug}`;

                            case 7:
                              return `${serviceHubSlug}/${item?.slug}`;

                            default:
                              return `${serviceHubSlug}/${item?.slug}`;
                          }
                        })()}
                        passHref
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        <Image
                          className="banner-card"
                          src={item?.mobileImage?.secureHttpPath}
                          width={1000}
                          height={1000}
                          alt={item?.heading}
                          loading="lazy"
                        />
                      </Link>
                    ) : (
                      <Image
                        className="banner-card"
                        src={item?.mobileImage?.secureHttpPath}
                        width={1000}
                        height={1000}
                        alt={item?.heading}
                        loading="lazy"
                        onClick={() =>
                          handleClick(
                            item?.bannerTypeCode,
                            item?.pageContentId,
                            item?.slug
                          )
                        }
                      />
                    )}
                  </Box>
                ))
              : Array.from({ length: 4 }).map((_, i) => (
                  <Skeleton
                    key={i}
                    variant="rounded"
                    sx={{
                      margin: "2rem 0.5rem",
                      width: { xs: "350px", sm: "500px" },
                      height: { xs: "200px", sm: "240px" },
                    }}
                  />
                ))}
          </Slider>
          {loader && <Loader />}
          <ScannerAuth
            openInfo={openInfo}
            handleClose={() => setOpenInfo(false)}
            id={bannerId}
            slug={slug}
            serviceHubSlug={serviceHubSlug}
          />
        </Box>
      )}
    </>
  );
};

export default Banner;
